<template >
  <div class="mainbody">
    <el-row :gutter="16">
      <el-col :span="12">
        <h3 class="title">加入的校友</h3>
      </el-col>
      <el-col :span="12">
        <div class="export-btn">
          <el-link :underline="false" target="_blank" :href="exportUrl" :disabled="isExport">
            <el-button type="success" size="medium" :disabled="isExport">导出</el-button>
          </el-link>
        </div>
      </el-col>
    </el-row>
    <!-- <div style="padding: 16px 32px 16px 0px">
      <span class="title">加入的校友</span>
      <el-button
        type="primary"
        size="small"
        style="float: right"
        @click="addImage()"
        >新增</el-button
      >
    </div>-->
    <div class="tableInfo">
      <el-row :gutter="24" justify="center">
        <el-col
          :span="6"
          v-for="item in data_list"
          :key="item.id"
          :offset="0"
          style="margin-bottom: 23px"
        >
          <el-card :body-style="{
              padding: '16px 0 16px 38px'
            }">
            <p
              class="name"
              @click="toUserDetails(item)"
            >{{ item.name_cn + '(' + item.name_en + ')' }}</p>
            <div class="info_div">
              <p class="title1">参与活动</p>
              <p class="title2">{{ item.joinActivityCount }}次</p>
            </div>
            <div class="info_div">
              <p class="title1">加入日期</p>
              <p class="title2">{{ item.createTime }}</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1
    };
  },
  created() {
    this.getList();
  },
  computed: {
    exportUrl() {
        var url = `${URL_PATH}api/adminAppletsAssociation/exportAssociationAlumni?association_id=${this.$route.query.id}&token=${localStorage.getItem("token")}`
        return url;
    },
    isExport() {
      return this.data_list.length === 0;
    }
  },
  methods: {
    getList: function() {
      this.$api
        .associationJoinList({
          token: localStorage.getItem("token"),
          association_id: this.$route.query.id,
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach(info => {
            info.createTime = Utils.dateFormat1(info.create_time * 1000);
          });
        })
        .catch(({ error }) => {});
    },
    // 查看学生详情 details
    toUserDetails(row) {
      this.$emit("toUserDetails", row);
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.name {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #474747;
  margin-bottom: 16px;
  cursor: pointer;
}
.info_div {
  width: 90px;
  float: left;
  margin-bottom: 8px;
}
.info_div .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #8c8c8c;
}
.info_div .title2 {
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  color: #595959;
}
.export-btn {
  text-align: right;
  padding: 16px 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/association/associationJoinList.vue